// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ColorVariants":"bbl_a bht_i bht_j","ColorVariants__color":"bbl_b bht_rp","ColorVariants__more":"bbl_c bht_vv"};